import React from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import OtpCode from '../Partials/OtpCode/OtpCode';
import InternetOtpCode from '../Partials/OtpCode/InternetOtpCode';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { setIsSubmit, setOtpErrorMsg, setOtpRestrictCodeError, setOtpAttempts, setOtpTicketId } from '../saleJetBlockSlice';
import { createOtp, validateOtp } from '../saleBlockAsyncThunk';

const OtpVerifyCodePage = (props) => {
  const otpFlow = props.otpDetails?.otpFlow;
  const isInternetCustomerInfoOtp =
    props.saleType === 'internet' &&
    (otpFlow === 'internetCustomerInfo' || otpFlow === 'internetCustomerInfoGuest');
  const isInternetPaymentContactOtp = props.saleType === 'internet' && otpFlow === 'internetPaymentContactOtp';
  const isInternetSaleOtp = isInternetCustomerInfoOtp || isInternetPaymentContactOtp;
  const restrictedCodeRequired = Boolean(props.otpDetails?.restrictedCodeRequired);

  //page params
  let isDisplayFooter = true;
  let btnText = isInternetSaleOtp ? 'בואו נתקדם' : 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const numberOfInputs = 6;
  //page params

  let currentPageHeadline = isInternetSaleOtp ? null : (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> שלחנו קוד אימות, הגיע? </h1>
      <h2 className='sale-title-small'> יש להקליד את הקוד שקיבלת בהודעה </h2>
    </div>
  );

  let currentPageView = isInternetSaleOtp ? (
    <InternetOtpCode
      onSubmit={props.isSubmit}
      validateOtp={validateOtp}
      createOtp={createOtp}
      numberOfInputs={numberOfInputs}
      errorMsg={props.otpDetails.errorMsg}
      restrictCodeError={props.otpDetails.restrictCodeError}
      otpPhone={props.otpDetails.otpPhone}
      otpFlow={otpFlow}
      customerEmail={props.otpDetails.customerEmail}
      restrictedCodeRequired={restrictedCodeRequired}
    />
  ) : (
    <div>
      <OtpCode onSubmit={props.isSubmit} validateOtp={validateOtp} createOtp={createOtp} numberOfInputs={numberOfInputs} errorMsg={props.otpDetails.errorMsg} />
    </div>
  );

  return (
    <div className={`slideAnimation${isInternetSaleOtp ? ' internet-otp-verify-page' : ''}`}>
      {currentPageHeadline}
      <div className={`sale-page-content${isInternetSaleOtp ? ' full-width' : ''}`}>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    props.setIsSubmit(true);
  }

  function createOtp(isVoice) {
    props.setOtpErrorMsg('');
    props.setOtpRestrictCodeError('');
    if (props.otpDetails.numOfAttempts >= Config.verifyCodeAttemptsLimit) {
      props.setOtpErrorMsg('לא ניתן לבצע ניסיונות נוספים')
    }
    if (props.otpDetails.otpPhone) {
      props.createOtp({ isVoice: isVoice });
    }
  }

  function validateOtp(otpCode, restrictCode) {
    props.setOtpErrorMsg('');
    props.setOtpRestrictCodeError('');
    if (otpCode.length != numberOfInputs) {
      props.setIsSubmit(false);
      props.setOtpErrorMsg('יש להזין 6 תווים')
      return;
    }
    const restrictValue = String(restrictCode ?? '').trim();
    if (restrictedCodeRequired && !restrictValue) {
      props.setIsSubmit(false);
      props.setOtpRestrictCodeError('יש להזין קוד זיהוי');
      return;
    }
    props.validateOtp({ otpCode: otpCode, restrictCode: restrictValue });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    isSubmit: state.saleJetBlock.isSubmit,
    otpDetails: state.saleJetBlock.otpDetails,
    //other states
  };
};

const mapDispatchToProps = {
  setIsSubmit,
  setOtpErrorMsg,
  setOtpRestrictCodeError,
  showAppLoader,
  hideAppLoader,
  setOtpAttempts,
  setOtpTicketId,
  createOtp,
  validateOtp
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodePage);
